import { getRunState } from '../api/getRunState.js';

function asObject(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
}

export default async function loadInitialRunState({ packId, moduleId, track = 'quick' } = {}) {
  const response = await getRunState({
    packId,
    moduleId,
    track,
  });

  const data = asObject(response?.data);
  const run = asObject(data?.run);

  const responses =
    Object.keys(asObject(data?.responses)).length > 0
      ? asObject(data?.responses)
      : asObject(run?.responses);

  const context =
    Object.keys(asObject(data?.context)).length > 0
      ? asObject(data?.context)
      : asObject(run?.context);

  return {
    run,
    responses,
    context,
  };
}
